import { HTime } from "@shared/src/datatypes/HTime";

export class IStandStillDto {
    public routeId: number;
    public phaseId: number;
    public shipmentId: number;
    public iHavePricked: boolean;
    public comment: string;
    public timeStandStill: HTime;
    public moreTime: boolean;
    
    public static build(routeId: number, phaseId: number, shipmentId: number, iHavePricked: boolean, comment: string, time: HTime, moreTime: boolean): IStandStillDto{
        let standStill = new IStandStillDto();
        standStill.routeId = routeId;
        standStill.phaseId = phaseId;
        standStill.shipmentId = shipmentId;
        standStill.iHavePricked = iHavePricked;
        standStill.comment = comment;
        standStill.timeStandStill = time;
        standStill.moreTime = moreTime;
        return standStill;
    }

    public isValid(){
        if(this.routeId == null && this.phaseId == null && this.shipmentId == null)
            return false;
    
        if(this.timeStandStill == null)
            return false;
        return true;
    }
}
